import React from 'react';
import { TFunctionResult } from 'i18next';

export interface MultiPanelCardPanelProps {
    title: string|TFunctionResult;
    icon?: JSX.Element;
    id?: string;
    children: React.ReactNode;
}

export const MultiPanelCardPanel = (props: MultiPanelCardPanelProps) => props.children;
